module.exports = __webpack_public_path__ + "static/media/vencedor.518176e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/maiz/climasense/roya_maiz/curativa/vencedor.png
// module id = 1719
// module chunks = 3